import { GetPoliceReportQueryParamsType } from '@/modules/adjusterReportModules/adjusterReport/queries/policeReport/getPoliceReport/getPoliceReportQuery.type';
import { getPoliceReportFunction } from '@/modules/adjusterReportModules/adjusterReport/queries/policeReport/getPoliceReport/getPoliceReportQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getPoliceReportQueryOptions = (
  params: GetPoliceReportQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['getPoliceReport', params],
    queryFn: () => getPoliceReportFunction(params),
    enabled: true,
    meta: {
      onSuccess: params.onSuccess,
    },
  });
};
